<template>
  <b-modal id="updateUserDataEmployeeModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.userdataemployee.updateUserDataEmployeeHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="userDataEmployee">
      <b-col>
        <UserDataEmployeeUpdate :userDataEmployeeId="userDataEmployee['@id']"></UserDataEmployeeUpdate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import UserDataEmployeeUpdate from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'UpdateUserDataEmployeeModal',
  components: {
    UserDataEmployeeUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.userdataemployee.update.show
    },
    userDataEmployeePivot () {
      return this.$store.state.modals.userdataemployee.update.userDataEmployeePivot
    },
    close () {
      return this.$store.state.modals.userdataemployee.update.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'userDataEmployeePivot': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      userDataEmployee: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.userDataEmployeePivot) {
        this.userDataEmployee = Object.assign({}, this.userDataEmployeePivot)
        this.$store.state.modals.userdataemployee.update.show = 0
        this.$store.state.modals.userdataemployee.update.userDataEmployeePivot = null
        this.$bvModal.show('updateUserDataEmployeeModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.userdataemployee.update.close = 0
        this.$bvModal.hide('updateUserDataEmployeeModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
